module.exports = {
          srcSet: __webpack_public_path__ + "9bfefbee484d7306684a709861bcdd01-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "9bfefbee484d7306684a709861bcdd01-180.png",width: 180,height: 180}],
          src: __webpack_public_path__ + "9bfefbee484d7306684a709861bcdd01-180.png",
          toString:function(){return __webpack_public_path__ + "9bfefbee484d7306684a709861bcdd01-180.png"},
          
          width: 180,
          height: 180
        }